import { routes } from "@/constants/routes";
import { Screen } from "@/ui/components/Screen";
import { LoadingState } from "@/ui/components/StateViews";
import { useRouter } from "expo-router";
import { useEffect } from "react";

/** Legacy-Einstieg: immer zur Rebuild-Aufnahme (kein Tenant-Pfad). */
export default function NewAnimalRedirect() {
  const router = useRouter();
  useEffect(() => {
    router.replace(routes.myAnimalNew as any);
  }, [router]);
  return (
    <Screen>
      <LoadingState message="Weiterleitung…" />
    </Screen>
  );
}
